<template>
  <a-card :bordered="false" title="申请发票" :headStyle="{ fontSize: '18px' }">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="可开票订单">
        <InvoiceOrder v-if="isSuccess == 1"></InvoiceOrder>
      </a-tab-pane>
      <a-tab-pane key="2" tab="开票历史">
        <InvoiceHistory></InvoiceHistory>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import InvoiceHistory from '../components/InvoiceHistory'
import InvoiceOrder from '../components/InvoiceOrder'
import userHelper from '../../../utils/helper/userHelper'
import { mapActions } from 'vuex'
import { ACCESS_CLOUD_TOKEN } from '@/store/mutation-types'

export default {
  name: 'ApplyInvoice',
  components: {
    InvoiceHistory,
    InvoiceOrder
  },
  data() {
    return {
      isSuccess: 0
    }
  },
  mounted() {
    this.getCloudCode()
  },
  methods: {
    ...mapActions(['GetCloudToken']),
    //获取云仓token
    getCloudCode() {
      if (!this.$ls.get(ACCESS_CLOUD_TOKEN)) {
        const userInfo = this.$store.getters.userInfo
        let merchantId = userInfo.merchantId
        const childAccountId = userInfo.account && userInfo.account > 3 ? userInfo.account : 0
        let platformId = this.getPlatformConfig().platformId
        let validationKey = userHelper.getCloudMD5Code(String(merchantId), String(platformId))
        let parmas = {
          merchantOppId: merchantId,
          platformId: platformId,
          validationKey: validationKey,
          childAccountId: childAccountId
        }
        this.GetCloudToken(parmas)
          .then(res => {
            this.isSuccess = 1
          })
          .catch(err => {
            this.$message.error('登录失败')
          })
      } else {
        this.isSuccess = 1
      }
    }
  }
}
</script>

<style scoped>
</style>